"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var jdStoreApi = _interopRequireWildcard(require("@/api/jdStoreApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JdGoodsPriceRecordDialog',
  data: function data() {
    return {
      visible: false,
      loading: false,
      currentSkuId: null,
      recordList: []
    };
  },
  methods: {
    open: function open(row) {
      this.currentSkuId = row.skuId;
      this.visible = true;
      this.fetchRecords();
    },
    fetchRecords: function fetchRecords() {
      var _this = this;
      this.loading = true;
      jdStoreApi.getJdGoodsPriceAdjustRecords({
        skuId: this.currentSkuId,
        page: 1,
        limit: 20
      }).then(function (res) {
        var data = res || {};
        _this.recordList = Array.isArray(data.list) ? data.list : [];
      }).catch(function () {
        _this.recordList = [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.currentSkuId = null;
      this.recordList = [];
    },
    getRatioText: function getRatioText(row) {
      if (row.adjustRatio == null) return '--';
      var ratio = parseFloat(row.adjustRatio);
      if (isNaN(ratio)) return '--';
      return (ratio > 0 ? '+' : '') + ratio.toFixed(2) + '%';
    },
    getRatioClass: function getRatioClass(row) {
      if (row.adjustRatio == null) return '';
      var ratio = parseFloat(row.adjustRatio);
      if (isNaN(ratio)) return '';
      if (ratio > 0) return 'ratio-up';
      if (ratio < 0) return 'ratio-down';
      return '';
    }
  }
};